import React from 'react'

import ChoiceNumberButton from '@components/Button/ChoiceNumberButton/ChoiceNumberButton'
import { useFontSize } from '@hooks/useFontSize'

type ChoiceNumberButtonContainerProps = {
  questionNumber: number
  choiceNumber: number
  afterChoiceBorderTextBgStyle: string
  onClick: (choice: number) => void
  isInQuestionArea: boolean
}

const ChoiceNumberButtonContainer: React.FC<ChoiceNumberButtonContainerProps> = ({
  questionNumber,
  choiceNumber,
  afterChoiceBorderTextBgStyle,
  onClick,
  isInQuestionArea,
}) => {
  const [fontSize] = useFontSize()

  let buttonClassName = 'w-4 h-4 mb-[15px]'
  let buttonBackgroundClassName = 'mb-auto'
  if (isInQuestionArea) {
    buttonClassName = 'w-4 h-4 mb-[10px]' + ' '
    switch (fontSize) {
      case 'base': {
        buttonClassName += 'sm:w-4 sm:h-4 sm:mb-[13px]'
        buttonBackgroundClassName += ' ' + 'pt-[6px]'
        break
      }
      case 'small': {
        buttonClassName += 'sm:w-3 sm:h-3 sm:mb-[11px]'
        buttonBackgroundClassName += ' ' + 'pt-[5px]'
        break
      }
      case 'large': {
        buttonClassName += 'sm:w-5 sm:h-5 sm:mb-[16px]'
        buttonBackgroundClassName += ' ' + 'pt-[8px]'
      }
    }
  }

  const clickHandler = () => {
    onClick(choiceNumber)
  }

  const props = {
    questionNumber,
    choiceNumber,
    afterChoiceBorderTextBgStyle,
    clickHandler,
    buttonClassName,
    buttonBackgroundClassName,
    isInQuestionArea,
  }
  return <ChoiceNumberButton {...props} />
}

export default React.memo(ChoiceNumberButtonContainer)
